import { withVersions } from "v2/hocs/withVersions";
import { ExportPrivateKeyV1 } from "./ExportPrivateKey/v1";
import { ExportPrivateKeyV2 } from "./ExportPrivateKey/v2";

import withExportPrivateKey from "v2/components/ExportPrivateKey/hocs/withExportPrivateKey";
export const ExportPrivateKeyModal = withVersions({
  v1: withExportPrivateKey(ExportPrivateKeyV1),
  v2: withExportPrivateKey(ExportPrivateKeyV2),
});
